module.exports = "<main [@.disabled]=\"ua|isMobile\">\r\n  <router-outlet (activate)=\"onActivate($event)\"></router-outlet>\r\n</main>\r\n\r\n"